var map = {
	"./background": 2,
	"./background.svg": 2,
	"./beta-2": 3,
	"./beta-2.png": 3,
	"./component/filter": 4,
	"./component/filter.svg": 4,
	"./component/service": 5,
	"./component/service.svg": 5,
	"./component/sink": 6,
	"./component/sink.svg": 6,
	"./component/source": 7,
	"./component/source.svg": 7,
	"./favicon.ico": 19,
	"./logo_digitalwerk": 8,
	"./logo_digitalwerk.svg": 8,
	"./logo_digitalwerk_normal": 9,
	"./logo_digitalwerk_normal.png": 9,
	"./placeholder/plugin_image": 10,
	"./placeholder/plugin_image.png": 10,
	"./plugin_structure": 11,
	"./plugin_structure.png": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18;